module.exports = __webpack_public_path__ + "static/media/munch14.0a5d3141.wav";